<template>
    <div
        id="viewport"
        :class="{ 'viewport-fullscreen': fullscreen }"
        @click="activityUpdate()"
        @keypress="activityUpdate()"
    >
        <Notifications />
        <LoadScreen v-if="!updating || !userStore.loaded" />
        <BootScreen
            v-if="!bootDone"
            @loaded="bootDone = true"
        />

        <!-- Main app view -->
        <div
            v-if="!fullscreen"
            id="mainview"
        >
            <div
                id="appview"
                class="d-flex flex-column"
            >
                <NavBar :theme="theme" />
                <div
                    class="d-flex flex-row flex-grow-1"
                    style="overflow: hidden"
                >
                    <Sidebar />
                    <RouterView v-if="userStore.loaded" />
                </div>
            </div>
        </div>
        <!-- Full screen login view -->
        <div
            v-else
            id="mainview"
        >
            <RouterView v-if="userStore.loaded" />
        </div>

        <!-- Update overlay -->
        <UpdateApp v-if="updating" />

        <AppFooter />
        <FooterProgressbar />
    </div>
</template>

<style>
#appview {
    height: 100vh;
    width: 100vw;
}
</style>

<script>
import { getStorage, setStorage } from "@helpers/storage";
import AppFooter from "@components/AppFooter.vue";
import FooterProgressbar from "@components/FooterProgressbar.vue";
import LoadScreen from "@components/LoadScreen.vue";
import Mousetrap from "mousetrap";
import NavBar from "@components/NavBar.vue";
import Notifications from "@components/Notifications.vue";
import { RouterView } from "vue-router";
import Sidebar from "@components/Sidebar.vue";
import UpdateApp from "@components/UpdateApp.vue";
import eventbus from "@eventbus";
import { useUserStore } from "@stores/userStore";
import BootScreen from "@components/BootScreen.vue";

export default {
    name: "App",
    components: {
        AppFooter,
        BootScreen,
        FooterProgressbar,
        LoadScreen,
        NavBar,
        Notifications,
        RouterView,
        Sidebar,
        UpdateApp,
    },
    setup() {
        const userStore = useUserStore();
        return { userStore };
    },
    computed: {
        fullscreen() {
            return this.$route.meta.fullscreen;
        },
    },
    data() {
        return {
            bootDone: false,
            requires_update: false,
            theme: "light",
            updating: false,
        };
    },
    mounted() {
        eventbus.on("app-requires-update", this.appRequiresUpdate);
        eventbus.on("post-navigation", this.postNavigation);

        // Timed actions
        window.setInterval(() => {
            eventbus.emit("interval-60s");
        }, 60000);

        Mousetrap.bind("esc", function () {
            eventbus.emit("popup-close");
        });

        // Auto sign out
        this.checkSignOut();
        eventbus.on("interval-60s", this.checkSignOut);
        eventbus.on("overflow-hidden", this.overflow);
    },
    unmounted() {
        eventbus.off("interval-60s", this.checkSignOut);
        eventbus.off("overflow-hidden", this.overflow);
        eventbus.off("app-requires-update", this.appRequiresUpdate);
        eventbus.off("post-navigation", this.postNavigation);
    },
    methods: {
        activityUpdate() {
            if (getStorage("autoSignOut.enabled")) {
                const date = new Date();
                setStorage("autoSignOut.lastActive", Math.round(date.getTime() / 1000));
            }
        },
        appRequiresUpdate() {
            this.requires_update = true;
        },
        checkSignOut() {
            if (getStorage("autoSignOut.enabled") && getStorage("token")) {
                const max_time = 20 * 60;
                const date = new Date();
                const current_time_difference = Math.round(
                    date.getTime() / 1000 - getStorage("autoSignOut.lastActive"),
                );

                if (current_time_difference > max_time) {
                    this.$router.push("/logout");
                }
            }
        },
        overflow(val) {
            const body = document.getElementsByTagName("body")[0];

            if (val) {
                return body.classList.add("overflow-hidden");
            }

            body.classList.remove("overflow-hidden");
        },
        postNavigation() {
            if (this.requires_update) {
                this.updating = true;
                location.reload();
            }
        },
    },
};
</script>
